/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* THE CODE BELOW IS FOR HE GCLA About PAGE HERO IMAGE TABS */

(function(){
  const hero = document.getElementById('gcla-hero-img');
  if(!hero) return;

  const IMG = {
    facility: 'https://cdn.shopify.com/s/files/1/0319/8592/6203/files/front_of_Grand_Cru_Liquid_Assets_facility.jpg?v=1760123082',
    tasting:  'https://cdn.shopify.com/s/files/1/0319/8592/6203/files/Grand_Cru_Liquid_Assets_Office.jpg',
    cellar:   'https://cdn.shopify.com/s/files/1/0319/8592/6203/files/secure_wine_cellar.jpg'
  };

  const tabs = Array.from(document.querySelectorAll('.gcla-phototab'));

  function setActive(key){
    const next = IMG[key];
    if (next && hero.src !== next) hero.src = next;
    tabs.forEach(btn =>
      btn.setAttribute('aria-selected', btn.dataset.img === key ? 'true' : 'false')
    );
  }

  // Hover + focus (desktop & keyboard)
  tabs.forEach(btn => {
    const key = btn.dataset.img;
    btn.addEventListener('mouseenter', () => setActive(key));
    btn.addEventListener('focus', () => setActive(key));
  });

  // Touch fallback: click to change
  const isCoarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
  if (isCoarse) {
    tabs.forEach(btn =>
      btn.addEventListener('click', () => setActive(btn.dataset.img))
    );
  }

  // Initialize based on aria-selected
  const initial = tabs.find(b => b.getAttribute('aria-selected') === 'true');
  setActive(initial ? initial.dataset.img : 'tasting');
})();

/* THE CODE ABOVE IS FOR HE GCLA About PAGE HERO IMAGE TABS */
